<template>
  <div
    v-if="images.length"
    class="vacancy-card-new__media-wrap"
    :class="mediaScrollSelector"
  >
    <OverlayScrollbarsComponent
      ref="scroll"
      class="vacancy-card-new__media-inner"
      :options="{
        callbacks: {
          onScroll: checkScroll,
          onUpdated: checkScroll,
          onHostSizeChanged: checkScroll
        }
      }"
    >
      <div
        v-for="(image, imageIndex) in images"
        class="vacancy-card-new__media-item"
        :key="imageIndex"
      >
        <video
          v-if="isVideo(image)"
          :title="image.videoTitle"
          :alt="image.videoAlt"
        >
          <source
            :src="image.path"
            :type="image.type"
          >
          Your browser does not support the video tag.
        </video>

        <v-lazy-image
          v-else
          use-picture
          :src="image.path"
          :title="image.imageTitle"
          :alt="image.imageAlt"
        >
          <source
            type="image/webp"
            :srcset="image.path_web"
          >
        </v-lazy-image>
      </div>
    </OverlayScrollbarsComponent>
  </div>
  <div v-else class="vacancy-card-new__media-wrap _no-photo">
    <img src="@/assets/img/png/no-photo-placeholder.png"
         :alt="vacancy.title"
         class="vacancy-card-new__media-placeholder">
  </div>
</template>

<script>
  import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
  import { VIDEOS_MIME_TYPES } from '@/constants/files';

  import 'overlayscrollbars/css/OverlayScrollbars.css';

  export default {
    name: 'VacancyCardImages',

    components: {
      OverlayScrollbarsComponent
    },

    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        scroll: null
      };
    },
    computed: {
      images() {
        const name = (this.vacancy[1] || {}).name;

        return ((this.vacancy[3] || {}).images || []).map((image, i) => ({
          ...image,
          videoTitle: this.createTitleMixin(name, i === 0 ? null : i + 1, true),
          videoAlt: this.createAltMixin(name, i === 0 ? null : i + 1, true),
          imageTitle: this.createTitleMixin(name, i === 0 ? null : i + 1),
          imageAlt: this.createAltMixin(name, i === 0 ? null : i + 1)
        }));
      },

      mediaScrollSelector() {
        if (!this.scroll) {
          return null;
        }

        if (this.scroll.trackLength.y === this.scroll.handleLength.y) {
          return '_scroll-hidden';
        }

        if (this.scroll.ratio.y === 0) {
          return '_scroll-start';
        }

        if (this.scroll.ratio.y === 1) {
          return '_scroll-end';
        }

        return null;
      }
    },

    methods: {
      isVideo(file) {
        return VIDEOS_MIME_TYPES.includes(file.type);
      },

      checkScroll() {
        const instance = this.$refs['scroll'] && this.$refs['scroll']._osInstace;

        if (!instance) {
          return this.progress = null;
        }

        this.scroll = instance.scroll();
        // if(this.progress === 0) {
        //   this.$refs['scroll'].$el.classList.add('_scroll-start')
        // } else {
        //   this.$refs['scroll'].$el.classList.remove('_scroll-start')
        // }
        //
        // if (this.progress === 1) {
        //   this.$refs['scroll'].$el.classList.add('_scroll-end')
        // } else {
        //   this.$refs['scroll'].$el.classList.remove('_scroll-end')
        // }
      }
    },

    mounted() {
      this.checkScroll();
    }
  };
</script>
